import * as Yup from 'yup'

export const curriculumValidations = Yup.object().shape({
  title: Yup.string()
    .required('Title is required'),
  languageCode: Yup.string()
    .required('Language code is required'),
  gradeLevelId: Yup.number().required(),
});